// ErrorBoundary.jsx
import React, { Component } from "react";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null
    };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Uncaught error caught by ErrorBoundary:", error, errorInfo);
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
            backgroundColor: "#f8f8f8",
            padding: "16px",
            fontFamily: "Inter, sans-serif"
          }}
        >
          <div
            style={{
              backgroundColor: "#ffffff",
              padding: "32px",
              borderRadius: "12px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
              textAlign: "center",
              maxWidth: "448px",
              width: "100%",
              border: "1px solid #e0e0e0"
            }}
          >
            <div style={{ marginBottom: "24px" }}>
              {/* Updated SVG Icon: Exclamation mark in a circle */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                style={{
                  width: "64px",
                  height: "64px",
                  color: "#ffc107", // Warm yellow for warning
                  margin: "0 auto",
                  display: "block"
                }}
              >
                <path
                  fillRule="evenodd"
                  d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12ZM12 8.25a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75Zm0 8.25a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
            <h2
              style={{
                fontSize: "24px",
                fontWeight: "bold",
                color: "#333333",
                marginBottom: "8px"
              }}
            >
              Something Unexpected Happened!
            </h2>
            <p
              style={{
                color: "#555555",
                marginBottom: "24px"
              }}
            >
              We encountered an issue while loading this content. Please try refreshing the page.
            </p>
            <button
              onClick={() => window.location.reload()}
              style={{
                padding: "12px 24px",
                backgroundColor: "#007bff",
                color: "#ffffff",
                fontWeight: "600",
                borderRadius: "8px",
                boxShadow: "0 2px 5px rgba(0, 123, 255, 0.2)",
                transition: "background-color 0.3s ease-in-out",
                border: "none",
                cursor: "pointer",
                outline: "none"
              }}
              onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#0056b3")}
              onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#007bff")}
            >
              Reload Page
            </button>

            {window.location.hostname === "localhost" && (
              <details
                style={{
                  marginTop: "32px",
                  textAlign: "left",
                  backgroundColor: "#fcfcfc",
                  padding: "16px",
                  borderRadius: "8px",
                  border: "1px solid #e9e9e9",
                  fontSize: "14px",
                  color: "#666666",
                  overflow: "auto",
                  maxHeight: "240px"
                }}
              >
                <summary
                  style={{
                    cursor: "pointer",
                    fontWeight: "600",
                    color: "#444444"
                  }}
                >
                  Error Details (Local Development)
                </summary>
                {this.state.error && (
                  <p
                    style={{
                      marginTop: "8px",
                      wordBreak: "break-word"
                    }}
                  >
                    <strong>Error:</strong> {this.state.error.toString()}
                  </p>
                )}
                {this.state.errorInfo && (
                  <>
                    <p style={{ marginTop: "8px" }}>
                      <strong>Component Stack:</strong>
                    </p>
                    <pre
                      style={{
                        whiteSpace: "pre-wrap",
                        fontFamily: "monospace",
                        fontSize: "12px",
                        backgroundColor: "#f3f3f3",
                        padding: "8px",
                        borderRadius: "4px",
                        marginTop: "4px",
                        overflowX: "auto"
                      }}
                    >
                      {this.state.errorInfo.componentStack}
                    </pre>
                  </>
                )}
              </details>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
